import { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./DiamondProxyVoteItem.module.css";
import GreenCheckmark from "ManagementTeam/Shared/GreenCheckmark";
import ThumbsDownButton from "ManagementTeam/Shared/ThumbsDownButton";
import ThumbsUpButton from "ManagementTeam/Shared/ThumbsUpButton";
import EditButton from "ManagementTeam/Shared/EditButton";
import ProxyVoteIcon from "ManagementTeam/Shared/ProxyVoteIcon";
import ProxyCheckmark from "ManagementTeam/DashboardPage/ProxyCheckmark";

/**
 * View component. Shows information about the diamond and their voting status
 */

//voting status: yes, no, pending

export function DiamondProxyVoteItem({ diamondInfo, handleProxyVote }) {
  const [proxyVote, setProxyVote] = useState(diamondInfo.votingStatus);

  return (
    <div className={styles.container}>
      {diamondInfo.checkedIn === true ? (
        <div className={styles.checkmarkContainer}>
          {diamondInfo.checkedIn && !diamondInfo.proxyCheckedIn && (
            <GreenCheckmark className={styles.checkmark} />
          )}
          {diamondInfo.proxyCheckedIn && (
            <div className={styles.checkMark}>
              <ProxyCheckmark />
            </div>
          )}
          <div className={styles.checkmarkBackground}></div>
        </div>
      ) : null}

      <img
        src={diamondInfo.photo}
        alt={diamondInfo.firstName}
        className={styles.image}
      />
      <div>
        {diamondInfo.firstName} {diamondInfo.lastName}
      </div>
      <div>
        {proxyVote === "Pending" ? (
          <div className={styles.votesContainer}>
            <div className={styles.button}>
              <ThumbsUpButton
                onClick={() => {
                  handleProxyVote(diamondInfo, "Yes");
                  setProxyVote("Yes");
                }}
              />
            </div>
            <div>
              <ThumbsDownButton
                onClick={() => {
                  handleProxyVote(diamondInfo, "No");
                  setProxyVote("No");
                }}
              />
            </div>
          </div>
        ) : null}
        {proxyVote === "Yes" ? (
          <div className={styles.votesContainerWithEdit}>
            <div className={styles.editButton}>
              <EditButton
                onClick={() => {
                  handleProxyVote(diamondInfo, "Pending");
                  setProxyVote("Pending");
                }}
              />
            </div>
            <div className={styles.button}>
              <ThumbsUpButton isLocked={true} />
            </div>

            <ProxyVoteIcon />
          </div>
        ) : null}
        {proxyVote === "No" ? (
          <div className={styles.votesContainerWithEdit}>
            <div className={styles.editButton}>
              <EditButton
                onClick={() => {
                  handleProxyVote(diamondInfo, "Pending");
                  setProxyVote("Pending");
                }}
              />
            </div>
            <div className={styles.button}>
              <ThumbsDownButton isLocked={true} />
            </div>

            <ProxyVoteIcon />
          </div>
        ) : null}
      </div>
    </div>
  );
}

DiamondProxyVoteItem.propTypes = {
  diamondInfo: PropTypes.object,
};
